import { api } from '@/lib/api';
import type {
  WalkPlan,
  WalkPlanSchedule,
  WalkPlanPreview,
  CreateWalkPlanRequest,
  VerifyPlanPaymentRequest,
} from './types';

/** Vendor read-only grouping of recurring walk plans (nearest child walks under each plan). */
export async function fetch_vendor_walk_plans(): Promise<WalkPlan[]> {
  const res = await api.get<WalkPlan[]>('/vendor/walk-plans');
  return res.data;
}

/** Vendor one-time acceptance of a whole plan (confirms every awaiting walk at once). */
export async function accept_walk_plan(id: string): Promise<WalkPlan> {
  const res = await api.post<WalkPlan>(`/vendor/walk-plans/${id}/accept`);
  return res.data;
}

/** Vendor one-time rejection of a whole plan (declines every awaiting walk at once). */
export async function reject_walk_plan(id: string, reason?: string): Promise<WalkPlan> {
  const res = await api.post<WalkPlan>(`/vendor/walk-plans/${id}/reject`, { reason });
  return res.data;
}

// ---- User (pet-owner) walk-plan endpoints ----

/** Dry-run the schedule → concrete generated walks + total, before creating anything. */
export async function preview_walk_plan(input: WalkPlanSchedule): Promise<WalkPlanPreview> {
  const res = await api.post<WalkPlanPreview>('/user/walk-plans/preview', input);
  return res.data;
}

/** Create the plan (bulk-generates PENDING_PAYMENT child walks + one plan payment). */
export async function create_walk_plan(input: CreateWalkPlanRequest): Promise<WalkPlan> {
  const res = await api.post<WalkPlan>('/user/walk-plans', input);
  return res.data;
}

/** Dummy-gateway confirm (no razorpay checkout). Activates the plan. */
export async function pay_walk_plan(id: string): Promise<WalkPlan> {
  const res = await api.post<WalkPlan>(`/user/walk-plans/${id}/pay`);
  return res.data;
}

/** Verify a razorpay plan payment (post-checkout). */
export async function verify_walk_plan_payment(id: string, input: VerifyPlanPaymentRequest): Promise<WalkPlan> {
  const res = await api.post<WalkPlan>(`/user/walk-plans/${id}/pay/verify`, input);
  return res.data;
}

export async function fetch_my_walk_plans(): Promise<WalkPlan[]> {
  const res = await api.get<WalkPlan[]>('/user/walk-plans');
  return res.data;
}

export async function cancel_walk_plan(id: string, reason?: string): Promise<WalkPlan> {
  const res = await api.post<WalkPlan>(`/user/walk-plans/${id}/cancel`, { reason });
  return res.data;
}
